import React, { createContext, PropsWithChildren, useMemo } from 'react';
import { useCompany, useTracking } from '../hooks';

export const UtilsContext = createContext<{
  tracker?: any;
  company?: any;
}>({});

export const UtilsProvider: React.FC<PropsWithChildren> = ({ children }) => {
  const { tracker } = useTracking();
  const { company } = useCompany();

  const getContextValue = useMemo(() => ({ tracker, company }), [tracker, company]);

  return (
    <UtilsContext.Provider value={getContextValue}>
      {children}
    </UtilsContext.Provider>
  );
};
